module.exports = __webpack_public_path__ + "static/img/NA.01e8a658.svg";